import * as service from "../service";
import { store } from "../../store";

/**
 * Fetch the profile of the currently logged-in student.
 * Backend: GET /api/user/getStudentProfile
 */
export const getStudentProfileAPI = async () => {
  const { student } = store.getState().auth as any;
  try {
    const resp = await service.call("GET", "api/user/getStudentProfile", {
      user_id: student?.id,
    });
    return resp;
  } catch (err) {
    console.error(`getStudentProfileAPI ${err}`);
    return { status: -1, resp: err };
  }
};
